import * as React from 'react'

import { Box, IconBadge, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  compensationsCount: number
}

const Content = ({ compensationsCount }: Props) => {
  return (
    <Box
      background="champagne200"
      paddingX="s24"
      paddingY="s16"
      borderRadius={{ all: 'abs016' }}
      flexDirection="row"
      gap="s12"
    >
      <IconBadge size="s32" icon="flag" iconColor="grey000White" color="champagne1200" />
      <Text.Normal>
        {i18n.tp('contract_versions.flows.update.steps.role_level_salary.policy.delete_content', {
          count: compensationsCount,
        })}
      </Text.Normal>
    </Box>
  )
}

export default observer(Content)
